const buildUrl = (updates) => {
  const url = new URL(window.location.href);

  Object.entries(updates).forEach(([key, value]) => {
    if (value == null || value === "") {
      url.searchParams.delete(key);
      return;
    }

    url.searchParams.set(key, String(value));
  });

  return `${url.pathname}${url.search}${url.hash}`;
};

export const replaceQueryParams = (updates) => {
  try {
    window.history.replaceState({}, "", buildUrl(updates));
  } catch {
    // no-op
  }
};

export const reloadWithQueryParams = (updates) => {
  try {
    window.location.assign(buildUrl(updates));
  } catch {
    // no-op
  }
};

export const readSubmitButtonParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    username: params.get("u") || "",
    password: params.get("p") || "",
    code: params.get("r") || "",
    gov: params.get("g") === "1",
  };
};

export const writeSubmitButtonParams = ({ username, password, code, gov }) => {
  replaceQueryParams({
    u: username || null,
    p: password || null,
    r: code || null,
    g: gov ? "1" : "0",
  });
};

export const writeSectionQueryParam = (sectionId) => {
  replaceQueryParams({ seccao: sectionId || null });
};

export const reloadWithSectionQueryParam = (sectionId) => {
  reloadWithQueryParams({ seccao: sectionId || null });
};

export const readQueryParam = (key) => {
  if (!key) return "";

  try {
    return new URLSearchParams(window.location.search).get(key) || "";
  } catch {
    return "";
  }
};

export const writeQueryParam = (key, value) => {
  if (!key) return;
  replaceQueryParams({ [key]: value || null });
};
